export const serviceNameList = [
  { id: "childcare", name: "Childcare" },
  { id: "childcarePlus", name: "Enrichment" },
  { id: "virtual", name: "Virtual" },
  { id: "night_nurse", name: "Night Nurse" },
  { id: "cleaning", name: "Cleaning" },
  { id: "cooking", name: "Cooking" },
  { id: "housekeeping", name: "Housekeeping" },
];

export const eventTypeList = [
  { id: "appointment", name: "Booking" },
  { id: "interview", name: "Interview" },
  { id: "private", name: "Provider's Personal Event" },
];

export const enrichmentActivitiesList = [
  { id: "tutoring", name: "Tutoring" },
  { id: "artsAndCrafts", name: "Arts and Crafts" },
  { id: "musicAndDancing", name: "Music and Dancing" },
  { id: "acting", name: "Acting" },
  { id: "sports", name: "Sports" },
];

export const referenceStatusList = [
  { id: "unableToReach", name: "Unable to reach" },
  { id: "done", name: "Done" },
  { id: "badReference", name: "Bad reference" },
];

export const providerDashboardBackgroundList = [
  { id: "notResponded", name: "Not responded" },
  { id: "flagged", name: "Flagged" },
  { id: "completed", name: "Completed" },
];

export const providerDashboardVettingStatusList = [
  { id: "inProgress", name: "In progress" },
  { id: "completed", name: "Completed" },
  { id: "failedRejected", name: "Failed / Rejected" },
];

export const trueFalseOptions = [
  { id: true, name: "True" },
  { id: false, name: "False" },
];

export const dryRunOptions = [
  { id: true, name: "Test" },
  { id: false, name: "Send to Customers" },
];

export const dateToTimestamp = (date) => {
  return +new Date(date);
};
